<template>
  <FormSearchableSelect
    ref="selectField"
    :options="stockList"
    :value="value"
    @input="updateValue($event)"
    :placeholder="placeholder"
    :field="field"
    :loading="loading"
    :note="note"
    :dropdownAutoWidth="dropdownAutoWidth"
    :appendToBody="appendToBody"
  />
</template>

<script>
import _ from 'lodash'
import formField from '@/mixins/formField'

export default {
  name: "FormInputStockCode",
  mixins: [formField],
  props: {
    value: [String, Number],
    field: String,
    stockType: [String, Array],
    placeholder: {
      type: String,
      default: 'Stock Code'
    },
    dropdownAutoWidth: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    note: String
  },
  data() {
    return {
      loading: false,
      stockList: [],
    };
  },
  methods: {
    loadStockList() {
      this.loading = true
      this.$apiService.inventoryService.getStockList().then(response => {
        this.$data.stockList = response.data
          .filter(stock => {
            if(!stock.isActive)
              return false
            if(!this.$props.stockType)
              return true
            if(_.isArray(this.$props.stockType))
              return this.$props.stockType.indexOf(stock.type) != -1
            
            return stock.type == this.$props.stockType
          })
          .map(stock => {
            return {
              value: stock.id,
              name: `${stock.code} | ${stock.name}`,
              data: {
                code: stock.code,
                name: stock.name,
                type: stock.type
              }
            }
          })
      })
      .finally(() => {
        this.loading = false
      })
    },
    focus() {
      if(this.$refs.selectField)
        this.$refs.selectField.focus()
    },
    select() {
      if(this.$refs.selectField)
        this.$refs.selectField.select()
    },
    updateValue(id) {
      this.$emit('input', id)

      // Update with extra info for the stock details
      let stockInfo = this.stockList.find(stock => stock.value == id)
      if(!stockInfo) {
        this.$emit('updateStockInfo', null)
      } else {
        this.$emit('updateStockInfo', {
          id: id,
          code: stockInfo.data.code,
          name: stockInfo.data.name,
          type: stockInfo.data.type
        })
      }
    }
  },
  watch: {
    stockType: function() {
      this.loadStockList()
    }
  },
  mounted() {
    this.loadStockList()
  },
  beforeDestroy() {
  }
};
</script>